var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card m-1",staticStyle:{"width":"300px"}},[_c('div',{staticClass:"card-body d-flex flex-column justify-content-center"},[_c('div',{staticClass:"p-2 cap-first",staticStyle:{"min-height":"90px"}},[_vm._v(_vm._s(_vm.description))]),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{name: 'suggestionsListAdder', params:
				 {suggestionsListId:
				 _vm.suggestionsListId,
				 modality: _vm.modality},
				 query: _vm.query
				 }}},[_c('IconText',{attrs:{"label":_vm.label,"icon":_vm.icon}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }